import React from "react";
import { useTranslation } from "react-i18next";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Button from "../../../../../../../components/button";
import {
  ButtonSize,
  ButtonVariant,
} from "../../../../../../../components/button/types";

interface ErrorStepProps {
  error: string | null;
  onRetry: () => void; // A function to clear the error and let the user try again
}

export const ErrorStep: React.FC<ErrorStepProps> = ({ error, onRetry }) => {
  const { t } = useTranslation("cvEditor");

  return (
    <div className="p-6 flex flex-col h-full items-center justify-center text-center">
      <div className="flex flex-col items-center">
        <ErrorOutlineIcon className="text-red-800" sx={{ fontSize: 60 }} />
        <h3 className="mt-4 text-xl font-semibold text-gray-800">
          {t("errors.mainTitle")}
        </h3>
        <p className="mt-2 text-sm text-gray-500 max-w-sm">
          {t("errors.description")}
        </p>
        {/* {error && (
          <div className="mt-4 p-3 bg-red-50 text-red-700 text-xs rounded-md border border-red-200 w-full max-w-sm">
            {error}
          </div>
        )} */}
        <Button
          variant={ButtonVariant.PRIMARY}
          size={ButtonSize.SMALL}
          onClick={onRetry}
          className="mt-6"
        >
          {t("common.tryAgain")}
        </Button>
      </div>
    </div>
  );
};
